// @flow
import {observable, toJS} from 'mobx'
import * as t from '../entities'
import * as cf from 'cf'

type Store = {
  mode: t.AbMode,
  modes: {[gridName:t.GridName]:t.AbMode[]},
  hasActiveTest: boolean,
  getMode: (gridName:t.GridName, row:number) => t.AbMode,
  setMode: (gridName:t.GridName, row:number, mode:t.AbMode) => void
}

const store:Store = observable(({
  mode: 'b',
  modes: {},
  get hasActiveTest() {
    for(let gridName in store.modes){ // $FlowFixMe
      for(let mode of store.modes[gridName]) {
        if(mode !== 'none') return true
      }
    }
    return false
  },
  getMode: (gridName, row) => {
    return store.modes[gridName][row] || 'none'
  },
  setMode: (gridName, row, mode) => {
    let newMode = []
    if(row > store.modes[gridName].length){
      newMode = Array(row+1).fill().map((_,i) => store.modes[gridName][i] || 'none')
      store.modes[gridName] = newMode
    }
    store.modes[gridName][row] = mode
    const story = cf.getStory()
    cf.update(story)
  }
}:Store))

function writeStory(story){
  // const story = cf.getStory()
  for(let gridName in story.GRID){
    gridName = (gridName:any)
    const grid = story.GRID[gridName]
    let rows = toJS(store.modes[gridName])
    const displayedRows = grid.content.split('\n').length-1
    grid.abTest = null
    if(rows.length > displayedRows){
      rows = rows.slice(0, displayedRows)
    }
    if(rows.find(mode => mode && mode !== 'none')){
      console.log(rows)
      grid.abTest = {
        rows: rows,
        a: createGrid(grid, rows, 'b'),
        b: createGrid(grid, rows, 'a')
      }
    }
  }
  return story
}

window.abStore = store

function createGrid (grid, rows, removeLetter) {
  const invalidRows = rows.reduce((p,n,i) => {
    if(n === removeLetter) p.push(i)
    return p
  }, [])
  const content = grid.content.split('\n').filter((_,i) => !invalidRows.includes(i)).join('\n')
  const invalidContent = grid.content.split('\n').filter((_,i) => invalidRows.includes(i)).join(' ')
  const components = grid.components.filter(name => !invalidContent.includes(` ${name} `))
  return { ...grid, content, components, abTest:null }
}

cf.addWriteMiddleware(writeStory)

cf.addChangeListener(story => {
  for(let gridName in story.GRID){
    gridName = (gridName:any)
    const grid = story.GRID[gridName]
    store.modes[gridName] = grid.abTest ? grid.abTest.rows : []
  }
})

export default store


// WEBPACK FOOTER //
// ./src/stores/abTest.js